import React, { useMemo, useState } from "react";
import { BellRing, CircleHelp, Mail, Save } from "lucide-react";
import "./componentes.css";

const CANAIS = [
  {
    campo: "notificacao_email_ativo",
    titulo: "E-mail",
    descricao: "Confirmações, alterações e lembretes enviados por e-mail.",
    icon: Mail,
    tooltip:
      "Ao ativar, vale só daí pra frente: próximos status e lembretes. Não reenvia avisos que já deveriam ter saído enquanto estava desligado.",
  },
  {
    campo: "notificacao_push_ativo",
    titulo: "Notificação no aplicativo",
    descricao: "Alertas para usuários que utilizam o aplicativo FilaZero.",
    icon: BellRing,
  },
];

const ConfiguracaoNotificacoes = ({ config, onSalvar, salvando = false }) => {
  const [dados, setDados] = useState({
    notificacao_email_ativo: Boolean(config.notificacao_email_ativo),
    notificacao_push_ativo: Boolean(config.notificacao_push_ativo),
  });

  const canaisAtivos = useMemo(
    () => CANAIS.filter(({ campo }) => dados[campo]).length,
    [dados]
  );

  const alterarCampo = (event) => {
    const { name, checked } = event.target;
    setDados((atual) => ({ ...atual, [name]: checked }));
  };

  const salvar = async () => {
    await onSalvar({
      ...dados,
      notificacao_sms_ativo: false,
      notificacao_whatsapp_ativo: false,
      notificacao_silencioso_inicio: null,
      notificacao_silencioso_fim: null,
    });
  };

  return (
    <section className="secao-config">
      <div className="section-heading">
        <div>
          <span className="section-eyebrow">COMUNICAÇÃO</span>
          <h2>Notificações</h2>
          <p>Escolha como clientes e equipe recebem avisos importantes da agenda.</p>
        </div>
        <span className="config-count">
          {canaisAtivos} {canaisAtivos === 1 ? "canal ativo" : "canais ativos"}
        </span>
      </div>

      <div className="notification-grid">
        {CANAIS.map(({ campo, titulo, descricao, icon: Icon, tooltip }) => (
          <label
            className={`notification-channel${dados[campo] ? " is-active" : ""}`}
            key={campo}
          >
            <span className="notification-channel__icon">
              <Icon size={20} />
            </span>
            <span className="notification-channel__copy">
              <span className="notification-channel__title">
                <strong>{titulo}</strong>
                {tooltip ? (
                  <span
                    className="fz-tooltip fz-tooltip--inline"
                    onClick={(event) => event.preventDefault()}
                    onKeyDown={(event) => event.stopPropagation()}
                  >
                    <button
                      type="button"
                      className="fz-tooltip__trigger"
                      aria-label={`Sobre ${titulo}`}
                      aria-describedby={`${campo}-tooltip`}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                      }}
                    >
                      <CircleHelp size={15} strokeWidth={2.25} />
                    </button>
                    <span id={`${campo}-tooltip`} className="fz-tooltip__bubble" role="tooltip">
                      {tooltip}
                    </span>
                  </span>
                ) : null}
              </span>
              <small>{descricao}</small>
            </span>
            <span className="fz-switch">
              <input
                type="checkbox"
                name={campo}
                checked={dados[campo]}
                onChange={alterarCampo}
              />
              <i />
            </span>
          </label>
        ))}
      </div>

      {!canaisAtivos && (
        <div className="availability-message is-erro" role="alert">
          Ative pelo menos um canal para que os avisos sejam enviados.
        </div>
      )}

      <button
        type="button"
        className="btn-salvar"
        onClick={salvar}
        disabled={!canaisAtivos || salvando}
      >
        <Save size={18} />
        {salvando ? "Salvando..." : "Salvar notificações"}
      </button>
    </section>
  );
};

export default ConfiguracaoNotificacoes;
